//Dependencies
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
//Database
import filters from '../../../databases/app/type';

/* FILTER - QUITO */
const Popover02 = (props) =>
{
  const { filter } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch(); 

  const onClickButton = (url) =>
  {
    navigate(url);
    dispatch({type: 'SET_LAST', last : null});

  }; 

  return(
    <div
      className = 'overflow-y-auto'
    >
      <div
        className = {`h-[40px] w-[300px] flex justify-center uppercase bg-transparent hover:bg-sky-500 text-gray-800 font-semibold hover:text-white border-2 border-gray-800 hover:border-transparent rounded my-1 cursor-pointer select-none`}
        onClick   = {() => onClickButton(`/`)}
      >
        <h1 
          className = 'flex items-center m-0'
        >
          TODOS
        </h1>
      </div>
      
      {filters && Object.keys(filters).map((m1, i) => 
        {          
          let info = filters[m1];         
          
          if (!info.visible) return null;

          return(
            <div
              key       = {i}
              className = {`h-[40px] w-[300px] flex justify-center uppercase bg-transparent hover:bg-sky-500 ${info.id === filter ? 'bg-sky-300' : ''} text-gray-800 font-semibold hover:text-white border-2 border-gray-800 hover:border-transparent rounded my-1 cursor-pointer select-none `}
              onClick   = {() => onClickButton(`/?f=${info.id}`)}
            >
              <h1 
                className = 'flex items-center m-0'
              >
                {info.text}
              </h1>
            </div>
          )
        })
      }      
    </div>
  );
}

export default Popover02;